require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-with-a-salon-in-neighbouring-kew-nailology-are-an.json") })
        }
      }, "path---news-with-a-salon-in-neighbouring-kew-nailology-are-an");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-with-a-salon-in-neighbouring-kew-nailology-are-an!./.cache/json/news-with-a-salon-in-neighbouring-kew-nailology-are-an.json
// module id = 867
// module chunks = 231608221292675